import { AsyncState, Updater, loadingAsyncState } from "widgets-for-react";
import { GetEventTemplateByEventId, getData } from "../../utils/api";
import { EventTemplate } from "../models/Events/Events";

export interface CourseDateScheduleState {
  eventId: string
  rf: string
  eventTemplateData: AsyncState<EventTemplate>
}

export const initialCourseDateScheduleState = (eventId: string, ref: string): CourseDateScheduleState => ({
  eventId: eventId,
  rf: ref,
  eventTemplateData: loadingAsyncState(() => getData<EventTemplate>(GetEventTemplateByEventId(eventId)))
})

export const CourseDateScheduleStateUpdaters = {
  updateEventData: (u: Updater<AsyncState<EventTemplate>>) => (state: CourseDateScheduleState): CourseDateScheduleState => ({...state, eventTemplateData: u(state.eventTemplateData)})
}
